export interface AbsencesRouter {
  goToDetail(id: string): void;
  goToList(query?: string): void;
  goToVacationDetail(query?: string): void;
  goToAbsencesDetail(query?: string): void;
  goToCreateBatch(params: {
    companyId: string;
    eventTypeId: string;
    employeeId?: string;
    parentEventId?: string;
  }): void;
  goToCreate(search: string): void;
  goBack(prevState: { pathname: string; search: string }): void;
  goToNewCompany(companyId: string, detail?: boolean): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AbsencesRouter = Symbol('AbsencesRouter');
